import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFormRecursionItemProps } from '.';

export const generate = (
  props?: Partial<IFormFieldSchema<IFormRecursionItemProps>>
): IFormFieldSchema<IFormRecursionItemProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.ARRAY,
    name: props?.name || id,
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-decorator': 'FormItem',
    'x-component': ComponentType.FormRecursionItem,
    'x-component-props': {
      title: '',
      buttonText: 'Add Item',
      buttonType: 'primary',
      buttonSize: 'middle',
      buttonVisible: true,
      canEditItem: true,
      canDeleteItem: true,
      canAddChildItem: true,
      childSchema: {
        type: JsonFieldType.VOID,
        name: 'childSchema',
        'x-component': ComponentType.ChildContainer,
        'x-component-props': {},
        'x-component-props-config': {},
        'x-designable-id': uuidv4(),
        'x-index': 0,
        properties: {
          childSchemaForm: {
            type: JsonFieldType.OBJECT,
            name: 'childSchemaForm',
            'x-component': ComponentType.Form,
            'x-component-props': {},
            'x-component-props-config': {},
            'x-designable-id': uuidv4(),
            'x-index': 0,
            properties: {
              'parent.id': {
                type: JsonFieldType.STRING,
                name: 'parent.id',
                title: 'Parent id',
                'x-designable-id': '55923b4a-3548-4e8f-9066-a7bc2733fbae',
                'x-index': 0,
                'x-decorator': 'FormItem',
                'x-component': ComponentType.FormInput,
                'x-validator': [],
                'x-component-props': {},
                'x-component-props-config': {},
                'x-decorator-props': {},
                'x-decorator-props-config': {},
                'x-display': 'hidden',
              },
            },
          },
        },
      },
    },
    'x-component-props-config': {},
  };
};
